import React from 'react';
// import '../CSS/inArea.css';

function InArea() {
    return (
        <div>
            <h2>מה באיזור</h2>
            <p className='text'>
                .בצמוד לצימר רוני יש בית כנסת וכן סופר ומקווה נשים במרחק של דקה שתיים הליכה<br />
                . נחל מודיעין זורם בחורף. פארק ענבה מודיעין <br />
                .גינות גדולות , שביל אופניים והשכרת אופניים<br />
                בסביבה מסעדות בשריות וחלביות כשרות למהדרין

            </p>
        </div>
    )
}

export default InArea